export default {
  getData: config => {
    const data = {};
    data.data = {
      pcConcLease: {
        "id|1-100": 100,
        projectName: "@cname()",
        "isDeduction|1-0": 0,
        "tContactId|1-100": 100
      },

      pcConcLeaseList: [
        {
          "id|1-100": 100,
          "tPcConcLeaseId|1-100": 100,
          materialCode: "@cname()",
          materialName: "@cname()",
          specifications: "@cname()",
          measuringUnit: "@cname()",
          rentType: "@cname()",
          "tenancyTerm|1-100": 100,
          "num|1-100": 100,
          priceExcludeTax: "@cname()",
          unitPriceExcludingTax: "@cname()",
          unitPriceIncludingTax: "@cname()",
          priceIncludeTax: "@cname()",
          tax: "@cname()",
          describe: "@cname()",
          remark: "@cname()",
          "outstandingQuantity|1-100": 100,
          "changeNum|1-100": 100,
          "isAdjustTaxFlag|1-100": 100
        }
      ],
      pcFinance: {
        "id|1-100": 100,
        province: "@cname()",
        city: "@cname()",
        county: "@cname()",
        deliverPlace: "@cname()",
        taxMethodCode: "@cname()",
        taxMethod: "@cname()",
        invoiceTypeCode: "@cname()",
        invoiceType: "@cname()",
        "contractNum|1-100": 100,
        materialSource: "@cname()",
        materialSourceCode: "@cname()",
        payTheCoefficient: "@cname()",
        prepayment: "@cname()",
        partyBId: "@cname()",
        signPlace: "@cname()",
        contractPerson: "@cname()",
        "businessType|1": '@pick(["01","02","03"])',
        "contractId|1-100": 100
      },
      concFiles: [
        {
          "id|1-100": 100,
          "businessId|1-100": 100,
          "businessType|1": '@pick(["01","02","03","04","05"])',
          "fileInfoId|1-100": 100,
          fileName: "@cname()",
          fileSize: "@cname()",
          fileType: "@cname()",
          fileUrl: "@cname()",
          fileDesc: "@cname()"
        }
      ]
    };
    data.code = "0";
    data.message = "查询成功";
    return data;
  }
};
